import React from 'react';
import { Table } from 'antd';
import { addHTTP } from '@utils/common';

function TabContent({ tableContent }) {
  const columns = [
    {
      title: 'title',
      dataIndex: 'title',
      key: 'title',
      className: 'keyContractContent-title',
    },
    {
      title: 'name',
      dataIndex: 'name',
      key: 'name',
      className: 'keyContractContent-name',
    },
    {
      title: 'linkedin',
      dataIndex: 'linkedin',
      key: 'linkedin',
      className: 'keyContractContent-linkedin',
      render: (link) => {
        if (link) {
          return (
            <span
              className="appkiticon icon-link-outline bg-434343"
              onClick={() => {
                window.open(addHTTP(link, 'http://'));
              }}
            />
          );
        }
      },
    },
  ];
  return (
    <Table
      dataSource={tableContent}
      columns={columns}
      pagination={false}
      scroll={{ y: 600 }}
    />
  );
}

export default TabContent;
